import EmpresaReducer from '@mec/stores/empresa/empresa.reducer'

export default { empresa: EmpresaReducer, }
